import { mapMutations } from "vuex";

export const attachmentfileactionMixin = {
  data() {
    return {
      dropedFiles: [],
      attachmentFiles: [],
      deleteAttachmentIds: [],

    };
  },

  methods: {
    ...mapMutations({
      setDropedFiles: "reply/setDropedFiles",
    }),
    saveAttachment(data) {
      if (this.dropedFiles.length !== 0) {
        data.forEach((item) => {
          if (!this.checkDuplicateFile(this.dropedFiles, item)) {
            this.dropedFiles.push(item);
          }
        });
      } else {
        this.dropedFiles = data;
      }
      this.setDropedFiles(this.dropedFiles)
    },

    removeAttchment(currentFile, action) {
      if (action == "new") {
        this.dropedFiles = this.dropedFiles.filter((file) => {
          return currentFile.name !== file.name;
        });
      }
      if (action === "old") {
        this.attachmentFiles = this.attachmentFiles.filter((file) => {
          if (currentFile.attachment_id === file.attachment_id) {
            this.deleteAttachmentIds.push(currentFile.attachment_id);
            this.removeFromExistingAttachmentIds(currentFile.attachment_id)
          }
          return currentFile.file_name !== file.file_name;
        });
      }
    },

  // atachments which we got from reply template and existing comment.
    removeFromExistingAttachmentIds(id) {
      if (this.existingAttachmentIds && this.existingAttachmentIds.includes(id)) {
        this.existingAttachmentIds = this.existingAttachmentIds.filter(existingId => existingId !== id);
      }
    },

    checkDuplicateFile(existingFile, file) {
      let duplicate = false;
      existingFile.forEach((existFile) => {
        if (existFile.name === file.name) duplicate = true;
      });
      return duplicate;
    },
  },
};
